module.exports = __webpack_public_path__ + "static/media/coloured-card.6e165911.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/assets-for-demo/presentationViewSectionComponent/coloured-card.jpg
// module id = 1167
// module chunks = 0